
export enum QuestionType {
    RadioButtons = "1",
    CheckBoxes = "2",
    TextAnswer = "4"
}